import React from "react";
import styled from "@emotion/styled";
import get from "lodash.get";
import { injectIntl } from "react-intl";

import VisitorCharacteristicsUtils from "services/visitorCharacteristics/utils";

import Section from "components/Section";
import StatsRow from "components/StatsRow";
import ToggleButtonGroup from "components/ToggleButtonGroup";

const ToggleButtonGroupContainer = styled.div`
  display: flex;
  flex: 1;
  margin-bottom: 10px;
`;

function QualitificationIndicatorsSection({
  intl,
  visitorCharacteristics,
  setQualificationIndicatorsFilters,
}) {
  const qualificationIndicatorsRow =
    VisitorCharacteristicsUtils.getQualificationIndicatorsRow(
      get(visitorCharacteristics, "qualificationIndicators"),
      intl
    );

  const options = new Array(7).fill(0).map((item, index) => ({
    label: intl.messages[`daysOfWeek.${index}`],
    value: index + 1,
  }));
  const selectedDays =
    get(visitorCharacteristics, "qualificationIndicators.filters.dow") &&
    Array.isArray(
      get(visitorCharacteristics, "qualificationIndicators.filters.dow")
    )
      ? get(visitorCharacteristics, "qualificationIndicators.filters.dow")
      : [get(visitorCharacteristics, "qualificationIndicators.filters.dow")];

  return (
    qualificationIndicatorsRow && (
      <Section
        title={
          intl.messages[
            "visitorCharacteristicsScene.sections.qualificationIndicators.title"
          ]
        }
      >
        <ToggleButtonGroupContainer>
          <ToggleButtonGroup
            loading={
              !visitorCharacteristics.qualificationIndicators.initialized
            }
            options={options}
            value={selectedDays || []}
            onChange={(e, value) => {
              if (
                value === null ||
                (Array.isArray(value) && value.length === 0)
              ) {
                return null;
              }
              return setQualificationIndicatorsFilters({ dow: value });
            }}
          />
        </ToggleButtonGroupContainer>

        <StatsRow
          initialized={get(
            visitorCharacteristics,
            "qualificationIndicators.initialized",
            false
          )}
          stats={qualificationIndicatorsRow}
          containerStyles={{ display: "flex", flexDiraction: "row" }}
          numberOfSection={qualificationIndicatorsRow.length}
        />
      </Section>
    )
  );
}

export default injectIntl(QualitificationIndicatorsSection);
